import appConfig from "../api/appConfig";
import SVG from "svg.js";

const Default = {
  animationSpeed: 3000,
  stroke: {
    color: '#f80404',
    width: 6,
    linecap: 'round',
    linejoin: 'round',
  },
  endPoint: {
    color: '#f80404',
    width: 10,
    ringColor: "rgba(243, 101, 101, .6)",
  },
  ...appConfig.pathFinder,
};

const drawPath = (svgId, pathNodes, animationEndCallback) => {
  const settings = {
    ...Default,
  };

  let State = {
    stop: false,
  };

  const pathLength = pathNodes[pathNodes.length - 1].distance;
  // this ensures that the animation speed is siaully consistend for all path lengths
  const animationSpeed = settings.animationSpeed * Math.sqrt(pathLength / 1000);

  const points = pathNodes.map(node => {
    let point = [];

    point[0] = node.$collection?.attr('cx');
    point[1] = node.$collection?.attr('cy');
    return point;
  }).filter(p => p[0] && p[1])

  if (!points || !points.length) {
    return;
  }

  const startingPoint = points[0];
  const endPoint = points[points.length - 1];

  const canvas = SVG(svgId);
  let Elements = {
    endPoint: {},
    pathLine: null,
  };

  const drawEndPoint = canvas => {
    if (State.stop) {
      return;
    }
    Elements.endPoint.innerCircle = canvas.circle(1).fill(settings.endPoint.color).attr({
      cx: endPoint[0],
      cy: endPoint[1],
    });
    Elements.endPoint.outerCircle = canvas.circle(1).fill('none').stroke({
      width: 3,
      color: settings.endPoint.ringColor,
    }).attr({
      cx: endPoint[0],
      cy: endPoint[1],
    });

    Elements.endPoint.innerCircle.animate(300).attr({
      r: settings.endPoint.width / 2,
    });

    Elements.endPoint.outerCircle.animate(300).attr({
      r: (settings.endPoint.width / 2) * 2.5,
    });
  };

  const drawLine = canvas => {
    Elements.pathLine = canvas.polyline(points).fill('none').stroke({
      ...settings.stroke,
    });
    Elements.pathLine.attr({
      'stroke-dasharray': pathLength,
      'stroke-dashoffset': pathLength,
    });

    const loopDrawLine = () => {
      if (State.stop) {
        return;
      }
      Elements.pathLine.animate(500).attr({
        'stroke-opacity': 0,
      }).animate(1).attr({
        'stroke-dashoffset': pathLength,
      }).animate(1).attr({
        'stroke-opacity': 1,
      }).animate(animationSpeed).attr({
        'stroke-dashoffset': 0,
      }).afterAll(loopDrawLine);
    };

    Elements.pathLine.animate(animationSpeed).attr({
      'stroke-dashoffset': 0,
    }).afterAll(function () {
      drawEndPoint(canvas);
      if (animationEndCallback) {
        animationEndCallback();
      }
      loopDrawLine();
    });
  };

  drawLine(canvas);

  const clear = function() {
    State.stop = true;

    if (Elements.endPoint.innerCircle) {
      Elements.endPoint.innerCircle.remove();
    }
    if (Elements.endPoint.outerCircle) {
      Elements.endPoint.outerCircle.remove();
    }
    if (Elements.pathLine) {
      Elements.pathLine.remove();
    }
  };

  return {
    clear,
  };

};

export default drawPath;